import React, { useCallback, useContext, useMemo } from 'react';
import cx from 'classnames';
import _get from 'lodash/get';
import ScribeSavedPoiDuck from 'ducks/scribe-saved-poi-duck';
import bookmarkFillSvg from 'public/icons/bookmark-fill.svg';
import bookmarkUnfillSvg from 'public/icons/bookmark-unfill.svg';
import GeoDuck from 'ducks/geo-duck';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { favoritePOIsSelector } from 'selectors/geo-selectors';
import styles from './styles.less';
import DeliveryContext from '../anytime-booking/common/context';

const SavedPoiCTAButton = ({
  poi,
  isPickUp,
  dispatch,
  postSavingPoiCallback,
  favoritesPOIs,
  className,
  scribeState,
}) => {
  const delivery = useContext(DeliveryContext);
  const currentFavoritePOI = useMemo(
    () =>
      favoritesPOIs &&
      favoritesPOIs.find(savedpoi => _get(savedpoi, 'id') === _get(poi, 'id')),
    [favoritesPOIs, poi],
  );

  const onClickSavedPoiButton = useCallback(
    () => {
      dispatch(
        GeoDuck.creators.openAddressDetailOverlay(
          currentFavoritePOI || poi,
          postSavingPoiCallback,
        ),
      );
      dispatch(
        ScribeSavedPoiDuck.creators.savePOIBookmark(
          scribeState,
          !!currentFavoritePOI,
          delivery,
          isPickUp,
        ),
      );
    },
    [
      currentFavoritePOI,
      poi,
      postSavingPoiCallback,
      dispatch,
      scribeState,
      delivery,
      isPickUp,
    ],
  );

  return (
    <div
      className={cx(styles.savedPoiCTAButton, className)}
      onClick={onClickSavedPoiButton}
    >
      <img
        src={!currentFavoritePOI ? bookmarkUnfillSvg : bookmarkFillSvg}
        alt="bookmark icon"
      />
    </div>
  );
};

SavedPoiCTAButton.propTypes = {
  poi: PropTypes.shape({}).isRequired,
  isPickUp: PropTypes.bool,
  dispatch: PropTypes.func.isRequired,
  postSavingPoiCallback: PropTypes.func,
  favoritesPOIs: PropTypes.arrayOf(PropTypes.shape({})),
  className: PropTypes.string,
  scribeState: PropTypes.string,
};

SavedPoiCTAButton.defaultProps = {
  isPickUp: false,
  postSavingPoiCallback: undefined,
  favoritesPOIs: undefined,
  className: undefined,
  scribeState: '',
};

export default connect(state => ({
  favoritesPOIs: favoritePOIsSelector(state),
}))(SavedPoiCTAButton);
